// extracted by mini-css-extract-plugin
export default {"myPerson":"MyPerson_myPerson__W4OZe","about":"MyPerson_about__bjnsc","myPhoto":"MyPerson_myPhoto__y-FYW"};